import React from "react";
import "./Tutorial.css";

const Tutorial = () => {
  return <div></div>;
};

export default Tutorial;
